"use client";

import { Field } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { useRef } from "react";
import { VideoControls } from "../../video-controls";
import classes from "./editorial-video.module.css";

export type EditorialVideoProps = {
  enableSound: Field<boolean>;
  enableAutoPlay: Field<boolean>;
  enableControls: Field<boolean>;
  videoUrl: string;
  classname: string;
};

const EditorialVideo = (props: EditorialVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div className={clsx(classes[props.classname], classes.videoContainer)}>
      <video
        data-testid="editorial-video"
        autoPlay={props.enableAutoPlay?.value}
        muted
        loop
        playsInline
        ref={videoRef}
        src={props.videoUrl}
      ></video>
      <VideoControls
        hasSound={props.enableSound?.value}
        videoRef={videoRef}
        componentName={"Editorial Video"}
      />
    </div>
  );
};

export default EditorialVideo;
